import { ChevronLeftIcon } from '@fingertip/icons'
import { observer } from 'mobx-react-lite'
import { useCallback, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { BookingStage } from '@/lib/stores/booker-store'
import { RootStoreContext } from '@/lib/stores/root-store'

import { Button } from '../../../ui/button'

type Props = {
  stage: BookingStage | null
}

export const BookerBack = observer(({ stage }: Props) => {
  const { t } = useTranslation()
  const {
    bookerStore: { setStage },
  } = useContext(RootStoreContext)

  const handleBack = useCallback(() => {
    setStage(stage)
  }, [setStage, stage])

  return (
    <Button variant="muted" size="sm" onClick={handleBack} type="button">
      <ChevronLeftIcon className="size-4 mr-1" />
      {t('back')}
    </Button>
  )
})
